import { Box, ButtonBase, InputAdornment } from '@mui/material';
import { UseDateFieldProps } from '@mui/x-date-pickers/DateField';
import { BaseSingleInputFieldProps, DateValidationError, FieldSection } from '@mui/x-date-pickers/models';
import { DateTime } from 'luxon';
import { DatePickerCalendarIcon } from '../Icons/CalendarIcon';
import { InputBaseWrapper } from '../TextInput/TextInputStyle';

interface ButtonFieldProps
  extends UseDateFieldProps<DateTime>,
    BaseSingleInputFieldProps<DateTime | null, DateTime, FieldSection, DateValidationError> {
  error?: boolean;
  placeholder?: string;
  onClick?: () => void;
}

function ButtonField({ value, error, placeholder, onClick, InputProps: { ref } = {} }: ButtonFieldProps) {
  return (
    <ButtonBase
      onClick={onClick}
      component="div"
      sx={{
        justifyContent: 'flex-start',
        cursor: 'pointer',
        '&:hover': {
          cursor: 'pointer',
        },
        caretColor: 'transparent',
        width: '100%',
      }}
      ref={ref}
      disableRipple
    >
      <InputBaseWrapper
        value={value ? value.toFormat('dd / MM / yyyy , HH:mm') : ''}
        placeholder={placeholder}
        error={error}
        readOnly
        inputProps={{
          readOnly: true,
          tabIndex: -1,
        }}
        endAdornment={
          <InputAdornment
            position="end"
            sx={{
              position: 'absolute',
              right: '0.75rem',
              height: '2rem',
              width: '2rem',
              margin: 0,
            }}
          >
            <DatePickerCalendarIcon width={32} height={32} />
          </InputAdornment>
        }
        sx={{
          textAlignLast: 'left',
          cursor: 'pointer',
          '& .MuiInputBase-input': {
            cursor: 'pointer',
          },
          '& .MuiInputBase-root': {
            pointerEvents: 'none',
          },
          width: '100%',
        }}
      />
    </ButtonBase>
  );
}

export default ButtonField;
